import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';

const WhatIsTesting: React.FC = () => {
  const { t } = useI18n();

  return (
    <section className="py-12 md:py-16">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-semibold mb-4">{t.sections.whatIsTesting.title}</h2>
        <p className="max-w-3xl mx-auto text-muted-foreground leading-relaxed">
          {t.sections.whatIsTesting.content}
        </p>
      </div>
    </section>
  );
};

export default WhatIsTesting; 